import type { PageData, ProfileGroup } from 'types/Page';

// The single rule for "analytics may show and query this profile", applied
// identically whether a profile is reached standalone or through a group.
// Deliberately does NOT require `isConnected`: a disconnected profile must stay
// visible so the user can reconnect it. `isBlank` marks a manually created
// profile — name and type only, never connected, so it has no analytics data.
export function isAnalyticsEligiblePage(page: PageData): boolean {
  return !!page.isSupportedInAnalytics && !page.isGlobal && !page.isBlank;
}

export function getAnalyticsEligiblePageIds(
  analyticsPages: PageData[],
): ReadonlySet<number> {
  return new Set(analyticsPages.map((page) => page.id));
}

export function omitIneligiblePagesFromProfileGroups(
  profileGroups: ProfileGroup[],
  eligiblePageIds: ReadonlySet<number>,
): ProfileGroup[] {
  return profileGroups.map((group) => {
    const eligiblePages = group.pages.filter((page) =>
      eligiblePageIds.has(page.id),
    );

    if (eligiblePages.length === group.pages.length) {
      return group;
    }

    return { ...group, pages: eligiblePages };
  });
}
